import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { getFileTypeIconProps } from '@uifabric/file-type-icons';
import { Link } from 'office-ui-fabric-react/lib/Link';
import styles from './DocumentsList.style';
import DetailsList from '../DetailsList';
import RemoveAttachmentsDialog from '../RemoveAttachmentsDialog';
import { noop } from '../../utils';

const DocumentsList = ({
  items,
  className,
  actionButtons,
  downloadDocument,
  deleteDocument,
  ...other
}) => {
  const [isRemovalRequested, setIsRemovalRequested] = useState();
  const [isRemoving, setIsRemoving] = useState(false);

  const downloadAction = () => {
    return {
      key: 'action',
      minWidth: 70,
      maxWidth: 70,
      columnActionsMode: 0,
      onRender: item => {
        return (
          // eslint-disable-next-line
          <Link onClick={() => downloadDocument(item, false)} className={styles.downloadButton}>
            Download
          </Link>
        );
      },
    };
  };
  const viewAction = () => {
    return {
      key: 'view',
      minWidth: 70,
      maxWidth: 70,
      columnActionsMode: 0,
      onRender: item => {
        return (
          // eslint-disable-next-line
          <Link
            onClick={() => downloadDocument(item, true)}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.viewButton}
          >
            View
          </Link>
        );
      },
    };
  };

  const handleAttachmentRemoval = item => {
    setIsRemoving(true);
    deleteDocument(item);
    setIsRemovalRequested();
    setIsRemoving(false);
  };
  const removeAction = () => {
    return {
      key: 'action',
      minWidth: 70,
      maxWidth: 70,
      columnActionsMode: 0,
      onRender: item => {
        // return nothing for this column if notRemovableFile flag is set
        if (item.notRemovableFile) {
          return null;
        }
        return (
          <>
            {/* eslint-disable-next-line */}
            <Link
              className={styles.removeButton}
              onClick={() => {
                setIsRemovalRequested(item.key);
              }}
            >
              Remove
            </Link>
            <RemoveAttachmentsDialog
              onDismiss={() => setIsRemovalRequested()}
              onSubmit={() => handleAttachmentRemoval(item)}
              isRemoving={isRemoving}
              attachmentName={item.documentName}
              hidden={isRemovalRequested !== item.key}
              dialogContentProps={{
                type: DialogType.normal,
                title: 'Remove Attachments',
                closeButtonAriaLabel: 'Close',
              }}
            />
          </>
        );
      },
    };
  };
  const constructDocumentListColumn = actionList => {
    const columns = [
      {
        key: 'icon',
        name: 'icon',
        minWidth: 8,
        maxWidth: 8,
        arianame: 'icon',
        iconName: 'Tag',
        isIconOnly: true,
        fieldName: 'icon',
        columnActionsMode: 0,
        onRender: item => {
          const [, extension] = item.documentName.split('.');
          return (
            <div className={styles.icon}>
              <FontIcon {...getFileTypeIconProps({ extension, size: 16, imageFileType: 'png' })} />
            </div>
          );
        },
      },
      {
        key: 'documentName',
        name: 'Document Name',
        fieldName: 'documentName',
        minWidth: 400,
        maxWidth: 600,
        columnActionsMode: 0,
      },
    ];

    actionList.forEach(action => {
      if (action === 'download') {
        columns.push(downloadAction());
      } else if (action === 'remove') {
        columns.push(removeAction());
      } else if (action === 'view') {
        columns.push(viewAction());
      }
    });

    columns.push({
      key: 'documentUploadTimeStamp',
      name: 'Attachment Upload Timestamp',
      fieldName: 'documentUploadTimeStamp',
      minWidth: 138,
      maxWidth: 138,
      columnActionsMode: 0,
    });

    return columns;
  };
  const documentColumns = constructDocumentListColumn(actionButtons);

  return (
    <DetailsList
      items={items}
      isHeaderVisible={false}
      columns={documentColumns}
      className={className}
      {...other}
    />
  );
};

DocumentsList.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      documentName: PropTypes.string.isRequired,
      documentLocation: PropTypes.string.isRequired,
    }),
  ),
  actionButtons: PropTypes.arrayOf(PropTypes.string).isRequired,
  downloadDocument: PropTypes.func,
  deleteDocument: PropTypes.func,
};

DocumentsList.defaultProps = {
  className: '',
  items: [],
  downloadDocument: noop,
  deleteDocument: noop,
};

export default DocumentsList;
